export enum WithdrawalMethod {
  BankAccount = 'BankAccount',
  Wallet = 'Wallet',
}
